import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  paypalCreateOrder: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/paypal-create-order/`,
  },
  paypalCaptureOrder: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/paypal-capture-order/`,
  },
  getOfferOnCancellation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/auto-offer-on-cancel/`,
  },
  extendSubscription: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/subscriptions/extend/`,
  },
  createStripeCheckoutSession: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/create-checkout-session/`,
  },
  createCustomerPortal: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/customer-portal/`,
  },

  hookBulkPricing: {
    method: 'POST',
    url: `${configs.baseUrl}/api/hook/bulk-licenses-requests/`,
  },
  createCustomerPortalUpgradeFlow: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/create-portal-flow-upgrade/`,
  },
  createCheckoutSessionForPersonPlan: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/create-checkout-session-for-personal-plan/`,
  },
  hookCustomRequest: {
    method: 'POST',
    url: `${configs.baseUrl}/api/hook/custom-plan-requests/`,
  },
  submitEnterpriseInquiriesForm: {
    method: 'POST',
    url: `${configs.baseUrl}/api/enterprise-inquiry/`,
  },
  // V2 endpoints for new bulk pricing
  createStripeCheckoutSessionV2: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/create-checkout-session-v2/`,
  },
  createCustomerPortalUpgradeFlowV2: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/create-portal-flow-upgrade-v2/`,
  },
  getMonthlyToYearlyUpgradePreview: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/yearly-upgrade-preview`,
  },
  createCustomerPortalUpgradeFlowV3: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/v3/create-portal-upgrade-flow/`,
  },
  // AHA-38492: Direct bulk purchase handler
  handleDirectBulkPurchase: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/direct-bulk-purchase`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const paypalCreateOrder = (payload) => {
  return resource.paypalCreateOrder(payload)
}
const createCheckoutSessionForPersonPlan = async (payload) => {
  const res = await resource.createCheckoutSessionForPersonPlan(payload)
  return res.body
}

/**
 * @deprecated
 * Use createCustomerPortalUpgradeFlowV2 instead
 */
const createCustomerPortalUpgradeFlow = async (payload) => {
  const res = await resource.createCustomerPortalUpgradeFlow(payload)
  return res.body
}
const paypalCaptureOrder = (payload) => {
  return resource.paypalCaptureOrder(payload)
}

const getOfferOnCancellation = () => {
  return resource.getOfferOnCancellation()
}

const extendSubscription = async () => {
  return resource.extendSubscription()
}

/**
 * @deprecated
 * Use createStripeCheckoutSessionV2 instead
 */
const createStripeCheckoutSession = async (payload) => {
  const res = await resource.createStripeCheckoutSession(payload)
  return res.body
}
const hookBulkPricing = async (payload) => {
  const res = await resource.hookBulkPricing(payload)
  return res.body
}
const createCustomerPortal = async (payload) => {
  const res = await resource.createCustomerPortal(payload)
  return res.body
}

const hookCustomRequest = async (payload) => {
  const res = await resource.hookCustomRequest(payload)
  return res.body
}

const submitEnterpriseInquiriesForm = async (payload) => {
  const res = await resource.submitEnterpriseInquiriesForm(payload)
  return res.body
}

// V2 API methods for new bulk pricing
const createStripeCheckoutSessionV2 = async (payload) => {
  const res = await resource.createStripeCheckoutSessionV2(payload)
  return res.body
}

const createCustomerPortalUpgradeFlowV2 = async (payload) => {
  const res = await resource.createCustomerPortalUpgradeFlowV2(payload)
  return res.body
}

const createCustomerPortalUpgradeFlowV3 = async (payload) => {
  const res = await resource.createCustomerPortalUpgradeFlowV3(payload)
  return res.body
}

const getMonthlyToYearlyUpgradePreview = async (payload) => {
  const res = await resource.getMonthlyToYearlyUpgradePreview(payload)
  return res.body
}

// AHA-38492: Direct bulk purchase handler
const handleDirectBulkPurchase = async (payload) => {
  const res = await resource.handleDirectBulkPurchase(payload)
  return res.body
}

export default {
  initResource,
  paypalCreateOrder,
  paypalCaptureOrder,
  getOfferOnCancellation,
  extendSubscription,
  createStripeCheckoutSession,
  hookBulkPricing,
  createCustomerPortal,
  createCustomerPortalUpgradeFlow,
  createCheckoutSessionForPersonPlan,
  hookCustomRequest,
  submitEnterpriseInquiriesForm,
  // V2 exports
  createStripeCheckoutSessionV2,
  createCustomerPortalUpgradeFlowV2,
  createCustomerPortalUpgradeFlowV3,
  getMonthlyToYearlyUpgradePreview,
  handleDirectBulkPurchase,
}
